// AUDITORIA-CLINICA-REDISENO (FASE 1) -- carga con skeletons de la FORMA
// FINAL de la pantalla (criterio de aceptación 7), no un spinner a pantalla
// completa: al llegar los datos nada salta de sitio.

const Bloque = ({ h = 14, w = "100%", mb = 0 }) => (
    <div className="ac-skel" style={{ height: h, width: w, marginBottom: mb }} />
);

function AtencionSkeleton() {
    return (
        <div className="page-content ac-page ac-atencion" data-testid="ac-skeleton" aria-busy="true" aria-live="polite">
            <div className="ac-topbar">
                <Bloque h={24} w={150} />
                <Bloque h={16} w={120} />
                <Bloque h={20} w={140} />
            </div>

            <div className="ac-identificacion">
                {[3, 2, 3, 2, 2, 3, 2, 4, 3].map((span, i) => (
                    <div className={`ac-campo ac-span-${span}`} key={i}>
                        <Bloque h={8} w={60} mb={6} />
                        <Bloque h={14} w="80%" />
                    </div>
                ))}
            </div>

            <div className="ac-cuerpo">
                <div className="ac-col-izq">
                    <div className="ac-panel">
                        <Bloque h={8} w={70} />
                        <Bloque h={6} />
                        {[0, 1, 2, 3, 4].map((i) => (
                            <Bloque key={i} h={16} />
                        ))}
                    </div>
                </div>
                <div className="ac-col-centro">
                    {[0, 1].map((i) => (
                        <div className="ac-seccion" key={i}>
                            <div className="ac-seccion__cabecera">
                                <Bloque h={16} w={180} />
                            </div>
                            <div className="ac-seccion__cuerpo">
                                <Bloque h={14} mb={8} />
                                <Bloque h={14} w="70%" />
                            </div>
                        </div>
                    ))}
                </div>
                <div className="ac-col-der">
                    <div className="ac-panel">
                        <Bloque h={8} w={90} />
                        <Bloque h={14} />
                        <Bloque h={14} w="60%" />
                    </div>
                </div>
            </div>
        </div>
    );
}

export default AtencionSkeleton;
